import { Navigate } from '@tanstack/react-router';
import { useAuth } from '@/hooks/useAuth';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Wrappt geschützte Routen. Wenn kein gültiger Token im Auth-Store liegt,
 * wird auf /login redirected (mit `redirect`-Query, damit die urspr. URL
 * später wiederhergestellt werden kann).
 */
export function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    const redirect = `${window.location.pathname}${window.location.search}`;
    return <Navigate to="/login" search={{ redirect }} replace />;
  }
  return <>{children}</>;
}
